import type { ReactNode } from "react";
import { Icon } from "@/components/Icon";

/**
 * A button with a small (i) on its top-right corner. With a mouse, hovering the button shows the
 * tip above it; clicking the (i), on any screen, toggles it in a line its parent shows (a touch
 * screen has no hover).
 */
export function CornerTip({
  id,
  label,
  tip,
  open,
  onToggle,
  children,
}: {
  id: string;
  label: string;
  tip: ReactNode;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <span className="tip-wrap">
      {children}
      <span id={id} role="tooltip" className="add-tip">
        {tip}
      </span>
      <button
        type="button"
        className="add-tip-dot"
        aria-label={`What ${label} does`}
        aria-expanded={open}
        onClick={onToggle}
      >
        <Icon name="info" size={16} />
      </button>
    </span>
  );
}
